enum UsuarioTipoEnum {
    Medico = 'Medico',
    Remuneracao = 'Remuneracao',
    Secretaria = 'Secretaria',
  }

export default UsuarioTipoEnum
